// extracted by mini-css-extract-plugin
module.exports = {"label":"StorePayment_label_2iBgJ","isLarge":"StorePayment_isLarge_1Z0Ca","paymentInput":"StorePayment_paymentInput_2SN7t"};